import { Form, Formik } from "formik";
import React from "react";
import { Link } from "react-router-dom";
import * as yup from "yup";
import FormikTextField from "../../components/Forms/FormikTextField";
import FormikTypeAhead from "../../components/Forms/FormikTypeAhead";
import LoaderButton from "../../components/LoaderButton";
import photo1 from "../../images/sofagirl.svg";
import FormImage from "../../layouts/formimage";
import { Constants } from "../../libs/Constants";
import { placeEvent } from "../../libs/eventsLib";
import {
  checkIfValidDate,
  getCurrentDate,
  getValidDate,
} from "../../libs/utils";
import useSignUpContext from "./contexts/useSignUpContext";
const initialValues = {
  firstName: "",
  lastName: "",
  companyEmail: "",
  company: "",
  employmentStartDate: "",
  dateOfBirth: "",
};
const schema = yup.object({
  firstName: yup.string().required("First Name is required"),
  lastName: yup.string().required("Last Name is required"),
  company: yup.string().required("You are required to select a company"),
  companyEmail: yup
    .string()
    .required("A valid work email is required")
    .email("A valid work email is required"),
  dateOfBirth: yup
    .string()
    .required("Date Of Birth is required")
    .test("validDate", function(value) {
      if (!checkIfValidDate(value)) {
        return this.createError({
          message:
            "Please enter your Date Of Birth in the correct format (MM/DD/YYYY).",
          path: "dateOfBirth",
        });
      }
      return true;
    })
    .test("dateOfBirth", function(value) {
      let dob = getValidDate(value, false);
      let currentDate = getCurrentDate(false);
      if (currentDate.diff(dob, "years") < 18) {
        return this.createError({
          message: "User should be older than 18 years.",
          path: "dateOfBirth",
        });
      }
      if (currentDate.diff(dob, "years") > 125) {
        return this.createError({
          message: "User should be younger than 125 years.",
          path: "dateOfBirth",
        });
      }
      return true;
    }),

  employmentStartDate: yup
    .string()
    .required("Employment Start Date is required")
    .test("validDate", function(value) {
      if (!checkIfValidDate(value)) {
        return this.createError({
          message: "Please enter valid date (MM/DD/YYYY).",
          path: "employmentStartDate",
        });
      }
      return true;
    }),
});

const UserDetails = ({ onSuccess }) => {
  const [companyDetails, setCompanyDetails] = React.useState(null);
  const {
    setCompany,
    setUser,
    user,
    company: companyInfo,
  } = useSignUpContext();

  const handleSubmit = async (values) => {
    setCompany(companyDetails);
    setUser({
      ...values,
    });

    let payload = {
      firstName: values.firstName,
      lastName: values.lastName,
      dateOfBirth: values["dateOfBirth"],
      email: values.companyEmail.toLowerCase(),
      company: companyDetails.name,
      employmentStartDate: values.employmentStartDate,
    };
    await placeEvent(
      Constants.EVENT_TYPES.PERSONAL,
      values.companyEmail.toLowerCase(),
      payload
    );
    onSuccess();
  };
  return (
    <FormImage
      title="Making ESPPs Simple"
      subtitle="Taabl gives you all the benefits of your ESPP without the
      payroll deduction."
      image={photo1}
      bgClass="background-green"
    >
      <React.Fragment>
        <h2 className="text-center pb-3">Sign up with Taabl</h2>
      </React.Fragment>
      <Formik
        validationSchema={schema}
        onSubmit={handleSubmit}
        initialValues={
          user && companyInfo
            ? { ...user, company: companyInfo.id }
            : initialValues
        }
        enableReinitialize
      >
        {({ isValid, isSubmitting }) => (
          <Form className="w-100">
            <div className="d-flex">
              <FormikTextField
                size="lg"
                controlId="firstName"
                label="First Name"
                type="text"
                name="firstName"
                className="mb-2 me-2"
              />
              <FormikTextField
                size="lg"
                controlId="lastName"
                label="Last Name"
                type="text"
                name="lastName"
                className="mb-2"
              />
            </div>
            <FormikTextField
              size="lg"
              controlId="dateOfBirth"
              label="Date Of Birth"
              type="text"
              name="dateOfBirth"
              className="mb-2"
              placeholder={Constants.DATEFORMAT.MMDDYYYY}
            />
            <FormikTextField
              size="lg"
              controlId="companyEmail"
              label="Work Email"
              type="text"
              name="companyEmail"
              className="mb-2"
            />
            <FormikTypeAhead
              size="lg"
              name="company"
              dbType={Constants.dbTypes.COMPANY}
              company={{
                id: Constants.ADMIN_COMPANY.id,
              }}
              labelId={"id"}
              labelKey={"name"}
              label="Company"
              placeholder="Search"
              className="mb-2"
              onChange={(value, companyList) => {
                let selectedCompany = companyList.find(
                  (comp) => comp.id === value
                );
                setCompanyDetails(selectedCompany);
              }}
            />
            <FormikTextField
              size="lg"
              controlId="employmentStartDate"
              label="Employment Start Date"
              type="text"
              name="employmentStartDate"
              className="mb-4"
              placeholder={Constants.DATEFORMAT.MMDDYYYY}
            />

            <LoaderButton
              block
              type="submit"
              variant="primary"
              size="lg"
              text="Next"
              className="mb-2"
              isLoading={isSubmitting}
              disabled={!isValid || isSubmitting}
            >
              Continue
            </LoaderButton>
          </Form>
        )}
      </Formik>
      <div className="d-flex justify-content-center pt-4 font-secondary account">
        Already have an account?
        <Link to="/login" className="secondary ps-1">
          Log in
        </Link>
      </div>
    </FormImage>
  );
};

export default UserDetails;
